import axios from "axios";
import { unauthorizedInterceptors } from "../utilities/functions";

const dashboardAPI = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/Report`,
  headers: {
    "Content-Type": "application/json",
  },
});
unauthorizedInterceptors(dashboardAPI);

const setAuthHeader = () => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    dashboardAPI.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
};

export const getDashboardFilters = async () => {
  setAuthHeader();
  return await dashboardAPI.get("/api/dashboard/filters/");
};

export const getDashboardData = async (filters = {}) => {
  setAuthHeader();
  return await dashboardAPI.post("/api/dashboard/data/", filters);
};

export const getDynamicFilterOptions = async (filters, filterType) => {
  try {
    setAuthHeader();
    
    const payload = { 
      ...filters, 
      exclude_filter: filters.exclude_filter || filterType 
    };
    
    const response = await dashboardAPI.post("/api/dashboard/filters/", payload);
    
    return response.data;
  } catch (error) {
    console.error("Error fetching dynamic filter options:", error);
    throw error;
  }
};

export const getCustomerLocationMap = async (filters = {}) => {
  try {
    setAuthHeader();
    
    // Log the filters being sent to the API
    console.log('Sending filters to customer location map API:', filters);
    
    // Use POST method with filters in the request body
    const response = await dashboardAPI.post("/api/customer-location-map/", filters);
    
    // Log the raw response data for debugging
    console.log('Raw API response:', response.data);
    
    // Ensure the response has the expected structure
    if (!response.data || typeof response.data !== 'object') {
      console.error('Invalid API response format:', response.data);
      throw new Error('Invalid API response format');
    }
    
    // If the response is directly the array of locations (without being wrapped in an object)
    if (Array.isArray(response.data)) {
      console.log('API returned array directly, wrapping in proper structure');
      return {
        locations: response.data,
        state_summary: {},
        top_cities: {
          by_customers: response.data.slice(0, 10).sort((a, b) => b.customer_count - a.customer_count),
          by_sales: response.data.slice(0, 10).sort((a, b) => b.total_sales - a.total_sales),
          by_profit: response.data.slice(0, 10).sort((a, b) => b.total_profit - a.total_profit)
        }
      };
    }
    
    // If the response already has the expected structure
    return response.data;
  } catch (error) {
    console.error("Error fetching customer location map data:", error);
    throw error;
  }
};
